<template v-if="$validateText(text)">
    <div :class="{ 'is-archived': model.isArchived }">
        {{ text }}
    </div>
</template>

<script>
export default {
    props: {
        document: {
            type: Object,
            required: true
        },
        model: {
            type: Object,
            required: true
        }
    },
    computed: {
        text() {
            const string = this.model.isArchived
                ? this.$translate(
                    'card_archived_text', 
                    '{card} är tyvärr inte tillgängligt längre. Vi har tagit fram ett liknande kort som du kanske är intresserad av.'
                )
                :this.$translate(
                    'card_alternative_text', 
                    'Vi samarbetar inte med {card} just nu och rekommenderar istället ett liknande kort.'
                );
            return string.replace('{card}', this.document.data.title);
        }
    }
};
</script>

<style lang="scss" scoped>
div {
    @include spacing(padding, 5);
    background: $lightgray;
    font-family: $fontText;
    @include font-size(16px, 10px);
    @include spacing(margin, 6, bottom);
    &.is-archived {
        background: $lightpink;
    }
}
</style>